import { defineMessages } from '@edx/frontend-platform/i18n';

const messages = defineMessages({
  errorMessage: {
    id: 'translations.error.unexpected.message.text',
    defaultMessage: 'Some content failed to translate. Please try again in a few minutes, contact support, or continue with non-translated content.',
    description: 'error message when an unexpected error occurs',
  },
  timeoutErrorMessage: {
    id: 'translations.error.timeout.message.text',
    defaultMessage: 'Translating this content is taking longer than expected.',
    description: 'error message when a timeout error occurs',
  },
  commonErrorMessage: {
    id: 'translations.error.common.message.text',
    defaultMessage: 'Please try again in a few minutes, contact support, or continue with non-translated content.',
    description: 'error messaging common to both loading error messages',
  },
  revertLanguageButtonLabel: {
    id: 'translations.error.revert.button.label',
    defaultMessage: 'Show Non-Translated Content',
    description: 'label for button that tries to reload by reverting language selection',
  },
  contactSupportButtonLabel: {
    id: 'translations.error.support.button.label',
    defaultMessage: 'Contact Support',
    description: 'label for button that opens contact support page',
  },
});

export default messages;
